<template>
  <structure>
    <b-row class="mt-2">
      <b-col>
        <p class="font-weight-bold">Today's email activity</p>
      </b-col>
    </b-row>
    <b-row class="graph justify-content-center">
      <activity-box
        style="cursor: pointer"
        v-for="(score, index) in this.$store.getters.activity"
        v-bind:size="37"
        v-bind:key="index"
        v-bind:time="parseInt(index)"
        v-bind:score="score"
      ></activity-box>
    </b-row>
    <b-row class="p-4 pt-2">
      <small class="mr-2">Less</small>
      <activity-box :score="0" :size="21" :time="false"></activity-box>
      <activity-box :score="2" :size="21" :time="false"></activity-box>
      <activity-box :score="4" :size="21" :time="false"></activity-box>
      <activity-box :score="6" :size="21" :time="false"></activity-box>
      <activity-box :score="8" :size="21" :time="false"></activity-box>
      <small class="ml-2 mr-2">More</small>
      <template v-if="showGoldScoreExplanation()">
        <activity-box :score="10" :size="21" :time="false"></activity-box>
        <small class="ml-1">WOW!</small>
      </template>
    </b-row>
    <b-row class="pl-2">
      <a
        class="btn btn-outline-primary"
        id="assign-manage"
        href="https://app.clockk.com/"
        target="_blank"
      >Assign &amp; Manage</a>
    </b-row>
  </structure>
</template>

<script>
import Structure from "./Structure";
import ActivityBox from "../tools/ActivityBox";

export default {
  name: "Home",
  components: {
    Structure,
    ActivityBox
  },
  extends: Structure,
  data() {
    return {};
  },
  async mounted() {},
  methods: {
    showGoldScoreExplanation() {
      let highScore = this.$store.getters.activity.find(score => score > 10);
      console.log("asdf", highScore);
      return highScore;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
